// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PopupTemplateFirst_wrapper__ii-ZL","box":"PopupTemplateFirst_box__2fIMB","box2":"PopupTemplateFirst_box2__17bHi","button":"PopupTemplateFirst_button__29lOa"};